import { render, staticRenderFns } from "./ManageAdminRights.vue?vue&type=template&id=f4223bd8"
import script from "./ManageAdminRights.vue?vue&type=script&lang=js"
export * from "./ManageAdminRights.vue?vue&type=script&lang=js"
import style0 from "./ManageAdminRights.vue?vue&type=style&index=0&id=f4223bd8&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4223bd8')) {
      api.createRecord('f4223bd8', component.options)
    } else {
      api.reload('f4223bd8', component.options)
    }
    module.hot.accept("./ManageAdminRights.vue?vue&type=template&id=f4223bd8", function () {
      api.rerender('f4223bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/ManageAdminRights.vue"
export default component.exports